import React from "react";
import { Spinner } from "react-activity";
const ActivityIndicator = () => {
  return /* @__PURE__ */ React.createElement("div", { className: "activity-indicator" }, /* @__PURE__ */ React.createElement(Spinner, null));
};
export default ActivityIndicator;
